import { render, staticRenderFns } from "./ReceivingGoodsDetail.vue?vue&type=template&id=7e53da10&"
import script from "./ReceivingGoodsDetail.vue?vue&type=script&lang=js&"
export * from "./ReceivingGoodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReceivingGoodsDetail.vue?vue&type=style&index=0&id=7e53da10&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e53da10')) {
      api.createRecord('7e53da10', component.options)
    } else {
      api.reload('7e53da10', component.options)
    }
    module.hot.accept("./ReceivingGoodsDetail.vue?vue&type=template&id=7e53da10&", function () {
      api.rerender('7e53da10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delivery/ReceivingGoodsDetail.vue"
export default component.exports